import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { type DocumentVersionSummary } from "~/api/types";
import { formatDate } from "~/helpers/date";
import { PublishReportProgress } from "./PublishReportProgress";

interface Props {
  data: DocumentVersionSummary;
}

const PublishReportCard = ({ data }: Props) => {
  const { t } = useTranslation();
  const publishedAt = formatDate(data.publishedAt);

  return (
    <div className="flex h-fit w-48 shrink-0 flex-col gap-2 rounded-lg border p-2">
      <div className="h-14">
        <Link
          to={`/documents/${data.document.id}?versionId=${data.id}&tab=anchoring`}
        >
          <div className="hover:text-primary line-clamp-2 text-sm">
            {data.title}
          </div>
        </Link>
        <div className="truncate text-xs text-gray-500">
          {data.document.category.title}
        </div>
      </div>
      <PublishReportProgress
        documentVersionId={data.id}
        totalCount={data.readers.totalCount}
        openedCount={data.readers.openedCount}
        readCount={data.readers.readCount}
        canSeeDetails
      />
      <div className="text-sm text-gray-500">
        {t(($) => $.commons.documentStatus.published)} {publishedAt}
      </div>
    </div>
  );
};

export default PublishReportCard;
